import http from '@/utils/http';
import httpApi from '@/apis/httpApi';

export const findPage = (data) => {
  return http.post({
    url: httpApi.taskModel.findPage,
    json: data,
  });
};
export const edit = (data) => {
  return http.post({
    url: httpApi.taskModel.edit,
    json: data,
  });
};
export const singleDetail = (data) => {
  return http.post({
    url: httpApi.taskModel.singleDetail,
    json: data,
  });
};
export const batchSwitch = (data) => {
  return http.post({
    url: httpApi.taskModel.batchSwitch,
    json: data,
  });
};

export const batchDel = (data) => {
  return http.post({
    url: httpApi.taskModel.batchDel,
    json: data,
  });
};

export const getBarSecGroup = () => {
  return http.get({
    url: httpApi.taskModel.getBarSecGroup,
  });
};
export const applyStrategy = (data) => {
  return http.post({
    url: httpApi.taskModel.applyStrategy,
    json: data,
  });
};
export const exeStrategyEditor = (data) => {
  return http.post({
    url: httpApi.taskModel.exeStrategyEditor,
    json: data,
  });
};
export const switchBarStatus = (data) => {
  return http.post({
    url: httpApi.taskModel.switchBarStatus,
    json: data,
  });
};
export const sysFileAdd = (data) => {
  return http.post({
    url: httpApi.taskModel.sysFileAdd,
    json: data,
  });
};
export const sysFilePage = (data) => {
  return http.post({
    url: httpApi.taskModel.sysFilePage,
    json: data,
  });
};
export const sysFileBatchDel = (data) => {
  return http.post({
    url: httpApi.taskModel.sysFileBatchDel,
    json: data,
  });
};
export const sysFileEdit = (data) => {
  return http.post({
    url: httpApi.taskModel.sysFileEdit,
    json: data,
  });
};
export const getHostProcs = () => {
  return http.get({
    url: httpApi.taskModel.getHostProcs,
  });
};
export const switchBarExeStatus = (data) => {
  return http.post({
    url: httpApi.taskModel.switchBarExeStatus,
    json: data,
  });
};
export const exeRunLog = (data) => {
  return http.post({
    url: httpApi.taskModel.exeRunLog,
    json: data,
  });
};
